import { InquiryProvider } from "../../components/Inquiary/context/InquiryContext"
import InquiryDetail from "../../components/Inquiary/InquiryDetail"

export default function InqauryDetailPage  () {
  return(
    <InquiryProvider>
    <InquiryDetail/>
    </InquiryProvider>
  )
}